/**
 * Hamilton x Bomber — Aviso de talla agotada
 * Muestra un popup configurable (texto + boton) al pasar el cursor (desktop)
 * o tocar (mobile) una talla agotada/tachada dentro del selector de variantes.
 * El contenido se configura en el bloque "Variant picker" del tema.
 */
(function () {
  if (window.__hamiltonVariantPopupInit) return;
  window.__hamiltonVariantPopupInit = true;

  var CHIP_SELECTOR = '.product-form__chip[dynamic-variant-button].disabled';
  var canHover = window.matchMedia('(hover: hover) and (pointer: fine)').matches;
  var HIDE_DELAY = 200;

  var active = null; // { el, chip }
  var hideTimer = null;

  function getConfig(chip) {
    if (chip.closest('[data-hamilton-pdp]')) return null;
    var wrapper = chip.closest('[data-product-variants]');
    if (!wrapper) return null;
    var cfg = wrapper.querySelector('[data-unavailable-popup-config]');
    if (!cfg) return null;
    var text = cfg.getAttribute('data-text') || '';
    if (!text) return null;
    return {
      text: text,
      buttonLabel: cfg.getAttribute('data-button-label') || '',
      buttonLink: cfg.getAttribute('data-button-link') || ''
    };
  }

  function buildPopup(cfg) {
    var pop = document.createElement('div');
    pop.className = 'variant-unavailable-popup';
    pop.setAttribute('role', 'dialog');
    pop.setAttribute('aria-live', 'polite');

    var close = document.createElement('button');
    close.type = 'button';
    close.className = 'variant-unavailable-popup__close';
    close.setAttribute('aria-label', 'Cerrar');
    close.innerHTML = '&times;';
    close.addEventListener('click', function (e) {
      e.preventDefault();
      e.stopPropagation();
      hide();
    });
    pop.appendChild(close);

    var msg = document.createElement('p');
    msg.className = 'variant-unavailable-popup__text';
    msg.textContent = cfg.text;
    pop.appendChild(msg);

    if (cfg.buttonLabel && cfg.buttonLink) {
      var btn = document.createElement('a');
      btn.className = 'variant-unavailable-popup__button';
      btn.href = cfg.buttonLink;
      btn.textContent = cfg.buttonLabel;
      if (/^https?:\/\//i.test(cfg.buttonLink)) {
        btn.target = '_blank';
        btn.rel = 'noopener';
      }
      pop.appendChild(btn);
    }

    return pop;
  }

  function position(pop, chip) {
    var rect = chip.getBoundingClientRect();
    var pr = pop.getBoundingClientRect();
    var margin = 8;
    var gap = 10;
    var doc = document.documentElement;

    var left = rect.left + rect.width / 2 - pr.width / 2 + window.scrollX;
    var minLeft = window.scrollX + margin;
    var maxLeft = window.scrollX + doc.clientWidth - pr.width - margin;
    if (left < minLeft) left = minLeft;
    if (left > maxLeft) left = maxLeft;

    var top;
    if (rect.top - pr.height - gap < 0) {
      // No cabe arriba: mostrar abajo
      top = rect.bottom + gap + window.scrollY;
      pop.classList.add('is-below');
    } else {
      top = rect.top - pr.height - gap + window.scrollY;
      pop.classList.remove('is-below');
    }

    // Punta del popup alineada al centro del chip
    var arrowLeft = rect.left + rect.width / 2 + window.scrollX - left;
    pop.style.setProperty('--arrow-left', arrowLeft + 'px');
    pop.style.top = top + 'px';
    pop.style.left = left + 'px';
  }

  function show(chip) {
    var cfg = getConfig(chip);
    if (!cfg) return;
    hide();
    var pop = buildPopup(cfg);
    document.body.appendChild(pop);
    active = { el: pop, chip: chip };
    position(pop, chip);

    if (canHover) {
      pop.addEventListener('mouseenter', function () { clearTimeout(hideTimer); });
      pop.addEventListener('mouseleave', scheduleHide);
    }

    requestAnimationFrame(function () { pop.classList.add('is-visible'); });
  }

  function hide() {
    clearTimeout(hideTimer);
    if (active) {
      active.el.remove();
      active = null;
    }
  }

  function scheduleHide() {
    clearTimeout(hideTimer);
    hideTimer = setTimeout(hide, HIDE_DELAY);
  }

  function chipFrom(e) {
    var chip = e.target && e.target.closest ? e.target.closest(CHIP_SELECTOR) : null;
    return chip && !chip.closest('[data-hamilton-pdp]') ? chip : null;
  }

  // Desktop: hover
  if (canHover) {
    document.addEventListener('mouseover', function (e) {
      var chip = chipFrom(e);
      if (chip) {
        clearTimeout(hideTimer);
        if (!active || active.chip !== chip) show(chip);
      }
    });
    document.addEventListener('mouseout', function (e) {
      if (chipFrom(e)) scheduleHide();
    });
  }

  // Tap / click (mobile + fallback). Capture phase para bloquear la seleccion
  // del variante agotado y solo mostrar el aviso.
  document.addEventListener('click', function (e) {
    var chip = chipFrom(e);
    if (chip) {
      e.preventDefault();
      e.stopPropagation();
      if (active && active.chip === chip) hide();
      else show(chip);
      return;
    }
    if (active && !(e.target.closest && e.target.closest('.variant-unavailable-popup'))) {
      hide();
    }
  }, true);

  // Reposicionar / cerrar
  window.addEventListener('resize', hide);
  window.addEventListener('scroll', function () {
    if (active) position(active.el, active.chip);
  }, { passive: true });
  document.addEventListener('keydown', function (e) {
    if (e.key === 'Escape') hide();
  });
})();
